import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Row from '../../../../../components/Basic/Blocks/Row';
import Button from '../../../../../components/Basic/Buttons/Button';
import H2 from '../../../../../components/Basic/WrapsStyle/H/H2';
import { TYPE_BUTTONS } from '../../../../../constans';

import UserApi from '../../../../../API/user/user-api';
import Column from '../../../../../components/Basic/Blocks/Column';
import PopUp from '../../../../../components/Basic/Blocks/PopUp';
import Input from '../../../../../components/Basic/Inputs/Base';
import DateInput from '../../../../../components/Basic/Inputs/Date';
import InputLabel from '../../../../../components/Basic/Inputs/LabelInput';
import Select from '../../../../../components/Basic/Inputs/Select';
import styles from './styles.module.scss';

const AddRetentionPopUp = ({ user = {}, close = () => { } }) => {
  const dispatch = useDispatch();
  const [day, setDay] = useState(new Date());
  const [name, setName] = useState(user.name);
  const [sum, setSum] = useState(0);
  // const [rate, setRate] = useState();
  const [comment, setComment] = useState();
  const [reason, setReason] = useState('');

  let onClickOk = () => {
    UserApi.addRetention({
      data: {
        userId: user._id,
        date: day, reason, sum: parseInt(sum), comment,
      }
    }).then((r) => close());
  };

  let disabled_button = false;
  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Добавить удержание</H2>
      <Input
        value={name}
        label="Имя"
        width="200px"
        onChange={(v) => setName(v)}
        style={{ marginBottom: '15px' }}
        disabled={true}
      />
      <Row>
        <Select
          select={reason}
          label="Причина"
          width="250px"
          onSelect={(v) => setReason(v)}
          list={[
            'Покупка',
            'Долг',
          ]}
          style={{ marginRight: '15px' }}
        />
        <Column style={{ marginRight: '10px' }}>
          <InputLabel>Дата</InputLabel>
          <Row style={{ width: '130px' }}>
            <DateInput value={day} className={styles.calendar} onChange={(v) => setDay(new Date(v))} />
          </Row>
        </Column>
      </Row>

      <Row>
        <Input
          value={comment}
          label="Комментарий"
          width="200px"
          onChange={(v) => setComment(v)}
          style={{ marginRight: '15px' }}
        />
        <Input value={sum} label="Сумма" width="200px" onChange={(v) => setSum(v)} />
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={disabled_button}
          onClick={onClickOk}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default AddRetentionPopUp;
